import React, { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { AuthShell, field } from '../ui'
import { attorneyAuth, attorneyApi } from '../api'

export function Signup() {
  const nav = useNavigate()
  const [params] = useSearchParams()
  const plan = params.get('plan')
  const wantsPlan = plan === 'standard' || plan === 'featured'
  const [form, setForm] = useState({ full_name: '', firm: '', email: '', password: '' })
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value })

  const submit = async (e) => {
    e.preventDefault()
    setError('')
    setBusy(true)
    try {
      await attorneyAuth.register(form)
      await attorneyAuth.login(form.email, form.password)
      // Carry the plan chosen on the landing straight to checkout — no
      // re-picking. If checkout isn't available, land on the portal instead.
      if (wantsPlan) {
        try {
          const { checkout_url } = await attorneyApi.checkout(plan)
          window.location.assign(checkout_url)
          return
        } catch {
          nav('/portal')
          return
        }
      }
      nav('/portal')
    } catch (err) {
      setError(err.message || 'Could not create your account')
      setBusy(false)
    }
  }

  return (
    <AuthShell
      title="Create your attorney account"
      subtitle="Step 1 of 3 — set up your login. You'll choose a plan and build your profile next."
    >
      <form className="space-y-4" onSubmit={submit}>
        <div className="grid gap-4 sm:grid-cols-2">
          <label className="block text-sm font-medium text-slate-700">Full name
            <input className={field} value={form.full_name} onChange={set('full_name')} required /></label>
          <label className="block text-sm font-medium text-slate-700">Firm
            <input className={field} value={form.firm} onChange={set('firm')} required /></label>
        </div>
        <label className="block text-sm font-medium text-slate-700">Email
          <input type="email" className={field} value={form.email} onChange={set('email')} required /></label>
        <label className="block text-sm font-medium text-slate-700">Password
          <input type="password" className={field} value={form.password} onChange={set('password')} minLength={8} required />
          <span className="mt-1 block text-xs text-slate-400">At least 8 characters.</span></label>
        {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
        <button type="submit" disabled={busy}
          className="w-full rounded-xl bg-gradient-to-r from-emerald-600 to-teal-600 py-3.5 text-base font-bold text-white shadow-lg transition hover:-translate-y-0.5 hover:from-emerald-700 hover:to-teal-700 disabled:cursor-not-allowed disabled:opacity-60">
          {busy ? 'Creating…' : 'Create account & continue'}
        </button>
      </form>
    </AuthShell>
  )
}

export default Signup
